export default "__VITE_ASSET__BpQ0k$fd__"